export default __webpack_public_path__ + "static/media/nfc-rfid-image.5a89c015.png";